/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AttributeValueFilter } from './attributeValueFilter';
import { PartitionValueFilter } from './partitionValueFilter';
import { RegistrationDateRangeFilter } from './registrationDateRangeFilter';


export interface BusinessObjectDataSearchKey { 
    /**
     * The Namespace to which a Business Object Format is related
     */
    namespace: string;
    /**
     * The name of the Business Object Definition to which a Business Object Format is related
     */
    businessObjectDefinitionName: string;
    /**
     * The Usage of this Business Object Format - a string describing how this format is used. Often used as a label for the Business                   Object Format. Does not have to be unique in the system, the Usage string is frequently shared across formats for multiple Business Object                   Definitions                
     */
    businessObjectFormatUsage?: string;
    /**
     * A File Type known to the system that describes the file type of data stored under a Business Object Format
     */
    businessObjectFormatFileType?: string;
    /**
     * The numeric version of a Business Object Format. Each time a format is registered, the new version will be the previous version                   + 1                
     */
    businessObjectFormatVersion?: number;
    /**
     * A container for Partition Value Filters
     */
    partitionValueFilters?: Array<PartitionValueFilter>;
    registrationDateRangeFilter?: RegistrationDateRangeFilter;
    /**
     * A container for Attribute Value Filters
     */
    attributeValueFilters?: Array<AttributeValueFilter>;
    /**
     * The business object is the latest valid version
     */
    filterOnLatestValidVersion?: boolean;
    /**
     * The filter for expired business object data with its business object format retention type as PARTITION_VALUE and the business                   object data partition value plus the retentionPeriodInDays specified in the business object format expired. Retention information specified                   in business object format is version less                
     */
    filterOnRetentionExpiration?: boolean;
    /**
     * The filter for business object data under legal hold
     */
    filterOnLegalHold?: boolean;
}
